import styled from 'styled-components';

const LayoutContentStyle = styled.div`
  width: 100%;
  padding: 16px;
  background-color: #ffffff;
  border: 1px solid #e9e9e9;
  height: 100%;
`;

export default LayoutContentStyle;
